<template>
  <div class="page-wrap stack-lg menu-page">
    <header class="menu-head glass">
      <div class="menu-head__main">
        <div>
          <h1 class="page-title">{{ displayName }}</h1>
        </div>

        <router-link to="/profile" class="menu-profile-link">
          Профиль
        </router-link>
      </div>
    </header>

    <section class="menu-section glass">
      <div class="menu-section__head">
        <h2>Финансы</h2>
      </div>

      <div class="menu-actions menu-actions--docs">
        <router-link to="/account-history" class="menu-action">
          <span class="menu-action__icon"><BaseIcon name="wallet" /></span>
          <span class="menu-action__body">
            <strong>История счёта</strong>
            <span>Бонусный счёт и история денежных транзакций</span>
          </span>
        </router-link>
      </div>
    </section>

    <section class="menu-section glass">
      <div class="menu-section__head">
        <h2>Документы</h2>
      </div>

      <div class="menu-actions menu-actions--docs">
        <router-link to="/privacy-policy" class="menu-action">
          <span class="menu-action__icon"><BaseIcon name="shield" /></span>
          <span class="menu-action__body">
            <strong>Политика конфиденциальности</strong>
            <span>Юридическая информация</span>
          </span>
        </router-link>

        <router-link to="/personal-data-consent" class="menu-action">
          <span class="menu-action__icon"><BaseIcon name="settings" /></span>
          <span class="menu-action__body">
            <strong>Согласие на обработку данных</strong>
            <span>Документ по персональным данным</span>
          </span>
        </router-link>
      </div>

      <BaseButton
        variant="secondary"
        block
        class="menu-logout"
        @click="logout"
      >
        Выйти из аккаунта
      </BaseButton>
    </section>

    <section v-if="isAdmin" class="menu-section glass">
      <div class="menu-section__head">
        <h2>Admin</h2>
      </div>

      <div class="menu-summary">
        <div class="menu-summary__item">
          <span>Всего броней</span>
          <strong>{{ stats.total || 0 }}</strong>
        </div>

        <div class="menu-summary__item">
          <span>Подтверждено</span>
          <strong>{{ stats.confirmed || 0 }}</strong>
        </div>

        <div class="menu-summary__item">
          <span>В процессе</span>
          <strong>{{ stats.in_progress || 0 }}</strong>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseButton from '../components/ui/BaseButton.vue';
import BaseIcon from '../components/ui/BaseIcon.vue';
import { userDisplayName } from '../utils/formatters';

export default {
  name: 'MenuView',
  components: {
    BaseButton,
    BaseIcon,
  },
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    stats() {
      return this.$store.getters['orders/stats'];
    },
    displayName() {
      return userDisplayName(this.user);
    },
  },
  async mounted() {
    await this.$store.dispatch('clubs/fetchClubs');

    if (this.user?.club_id) {
      await this.$store.dispatch('clubs/fetchClubById', this.user.club_id);
    }

    if (this.isAdmin) {
      this.$store.dispatch('orders/fetchStatistics');
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped src="./MenuView.css"></style>